<script lang="ts">
const layoutComponents = {
  BaseLayout,
  SimpleLayout,
  EmptyLayout,
  PrintLayout,
};
export type LayoutType = keyof typeof layoutComponents;
</script>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import BaseLayout from '@/components/layouts/BaseLayout/BaseLayout.vue';
import SimpleLayout from '@/components/layouts/SimpleLayout/SimpleLayout.vue';
import EmptyLayout from '@/components/layouts/EmptyLayout/EmptyLayout.vue';
import PrintLayout from '@/components/layouts/PrintLayout/PrintLayout.vue';
import NotificationPopUp from '@/components/notifications/NotificationPopUp.vue';
import ActionConfirmationModal from '@/components/confirmationModals/ActionConfirmationModal.vue';
import FormConfirmationModal from '@/components/confirmationModals/FormConfirmationModal.vue';
import { getDefaults } from '@/styles/vuetify';
import AboutDialog from '@/components/AboutDialog/AboutDialog.vue';
import { useAuthenticationStore } from '@/stores/authenticationStore';
import { useTranslation } from 'i18next-vue';
import { useAccountStore } from '@/stores/accountStore';
import { useTranslationKeyStore } from '@/stores/translationKeyStore';

const route = useRoute();
const layoutComponent = ref<LayoutType>();

const { i18next } = useTranslation();

const authenticatioStore = useAuthenticationStore();
const accountStore = useAccountStore();

const languageTimeZoneSwitchKey = computed(
  () =>
    `${i18next.language}${accountStore.timezone}${useTranslationKeyStore().showTranslationKeys}`,
);

// Switch Layout-Component, when new route requires another Layout
watch(
  () => route.name,
  (newRouteName) => {
    if (!newRouteName) return;
    layoutComponent.value =
      (typeof route.meta.layout === 'function'
        ? route.meta.layout(authenticatioStore.isAuthenticated)
        : route.meta.layout) ?? 'BaseLayout';
  },
  { immediate: true },
);
</script>

<template>
  <v-defaults-provider :key="languageTimeZoneSwitchKey" :defaults="getDefaults()">
    <ActionConfirmationModal>
      <FormConfirmationModal>
        <AboutDialog>
          <component :is="layoutComponents[layoutComponent]" v-if="layoutComponent">
            <slot />
          </component>
          <NotificationPopUp style="z-index: 2011" />
        </AboutDialog>
      </FormConfirmationModal>
    </ActionConfirmationModal>
  </v-defaults-provider>
</template>
